import { render, staticRenderFns } from "./BagEmptyState.vue?vue&type=template&id=113a164a&"
import script from "./BagEmptyState.vue?vue&type=script&lang=js&"
export * from "./BagEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconEmptyBag: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconEmptyBag.vue').default,AppContainer: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppContainer.vue').default})
